import { type ApprovalPoolLike } from '@webapp/core/interfaces/components/ApprovalPoolLike'
import { type UserLike } from '@webapp/core/interfaces/components/UserLike'

export class CheckIsApprovalPoolLikeUseCase {
  execute = (
    approver: ApprovalPoolLike | UserLike
  ): approver is ApprovalPoolLike => {
    return 'members' in approver && Array.isArray(approver.members)
  }
}
